import React, { useState } from 'react';

import { debounce, replace } from 'lodash';

import { ChipLoader } from 'components/v2';

import FiltersSelectHeader from '../FiltersSelectHeader';

import FiltersApproverData from './FiltersApproverData';

interface FiltersApproverProps {
  type?: string;
}

const FiltersApprover: React.FC<FiltersApproverProps> = ({ type = 'approver' }) => {
  const [regex, setRegex] = useState<string>('');

  // Workaround to search by firstname/lastname since root has difference between them and name
  const variables = {
    filter: {
      type: 'staff',
      _operators: { roles: { in: ['manager', 'admin'] } },
      ...(regex && {
        OR: [
          { _operators: { firstname: { regex: `(?i)(${regex})` } } },
          { _operators: { lastname: { regex: `(?i)(${regex})` } } },
        ],
      }),
    },
  };

  const handleOnSearchChange = (search: string) => setRegex(search && replace(search, ' ', '|'));

  return (
    <React.Fragment>
      <FiltersSelectHeader type={type} onSearchChange={debounce(handleOnSearchChange, 600)} />
      <FiltersApproverData type={type} variables={variables} />
    </React.Fragment>
  );
};

export default (props: FiltersApproverProps) => (
  <React.Suspense fallback={<ChipLoader />}>
    <FiltersApprover {...props} />
  </React.Suspense>
);
